import { presets } from '@yandex-int/messenger.widget';

export enum Environment {
    DEVELOPMENT = 'development',
    TESTING = 'testing',
    PRESTABLE = 'prestable',
    PRESTABLE2 = 'prestable2',
    PRODUCTION = 'production',
}

export type MessengerBackendPreset = keyof typeof presets.backend;
